(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["group"] && !Shopify.designMode) return;
  try {
    /*
   * Mobile carousel interactions
   *
   * 1. Mouse-drag support — lets the carousel scroll via click-and-drag in desktop
   *    browsers and the Shopify theme-editor preview, matching native touch behaviour.
   *
   * 2. Tap-to-navigate — when a .group-block__link sibling is present, a short tap
   *    (no significant movement) navigates to its href. On real mobile the browser
   *    never fires a click after a real swipe (movement > ~10 px), so the two gestures
   *    are naturally distinguished without any extra threshold logic.
   *
   * The handlers are registered once on document (guarded by _mbCarousel) so multiple
   * carousel blocks on the same page share a single listener pair.
   */
  (function () {
    if (window._mbCarousel) return;
    window._mbCarousel = true;

    var drag = { el: null, startX: 0, startScroll: 0, moved: false };

    document.addEventListener('mousedown', function (e) {
      var carousel = e.target.closest && e.target.closest('.mobile-carousel');
      if (!carousel || e.button !== 0) return;
      drag.el = carousel;
      drag.startX = e.clientX;
      drag.startScroll = carousel.scrollLeft;
      drag.moved = false;
      e.preventDefault(); // prevent text selection during drag
    });

    document.addEventListener('mousemove', function (e) {
      if (!drag.el) return;
      var delta = drag.startX - e.clientX;
      if (Math.abs(delta) > 5) drag.moved = true;
      drag.el.scrollLeft = drag.startScroll + delta;
    });

    document.addEventListener('mouseup', function () {
      drag.el = null;
    });

    /*
     * Click handler (capture phase so we can cancel it before other listeners).
     * - After a mouse-drag: swallow the synthetic click so it doesn't navigate.
     * - After a short tap/click on a carousel with a block link: navigate to the
     *   link's href.  We skip the navigation if the actual target is already an
     *   interactive element (a, button) so those keep their own click behaviour.
     */
    document.addEventListener('click', function (e) {
      var carousel = e.target.closest && e.target.closest('.mobile-carousel');
      if (!carousel) return;

      if (drag.moved) {
        drag.moved = false;
        e.preventDefault();
        return;
      }

      var link = carousel.previousElementSibling;
      if (!link || !link.classList.contains('group-block__link') || !link.href) return;
      if (e.target.closest('a, button')) return;

      if (link.target === '_blank') {
        window.open(link.href, '_blank', 'noopener');
      } else {
        window.location.href = link.href;
      }
    }, true);
  })();

  /*
   * Reversed carousel — visual reorder via CSS `order`.
   *
   * Sets flex `order` on each child to flip their visual position without
   * touching the DOM or scroll position. scrollLeft stays 0 so the carousel
   * always opens at the first reversed item and the user swipes left normally.
   * Cleared above 1079px so desktop layout is unaffected.
   */
  (function () {
    var mq = window.matchMedia('(max-width: 1079px)');

    function applyAll() {
      var isMobile = mq.matches;
      document.querySelectorAll('.mobile-carousel.reverse-mobile').forEach(function (carousel) {
        var children = Array.from(carousel.children);
        var n = children.length;
        children.forEach(function (child, i) {
          child.style.order = isMobile ? String(n - 1 - i) : '';
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyAll);
    } else {
      applyAll();
    }

    mq.addEventListener('change', applyAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grouping"] && !Shopify.designMode) return;
  try {
    (function () {
    // Reads the category label from a per-category legend (e.g. "Seasonal:  " -> "Seasonal").
    function getCategoryLabel(legend) {
      const labelSpan = legend?.querySelector('span:not(.product-grouping__color)');
      if (!labelSpan) return '';
      return labelSpan.textContent.replace(/:\s*$/, '').trim();
    }
    const boundContainers = new WeakSet();
    function getTopLegendSpans(productGrouping) {
      const topLegend = productGrouping.previousElementSibling;
      return {
        labelSpan: topLegend?.querySelector('[data-top-legend-label]') ?? null,
        valueSpan: topLegend?.querySelector('[data-top-legend-value]') ?? null,
      };
    }

    function setTopLegend(productGrouping, label, value) {
      const { labelSpan, valueSpan } = getTopLegendSpans(productGrouping);
      if (labelSpan && label != null) labelSpan.textContent = label;
      if (valueSpan && value != null) valueSpan.textContent = value;
    }

    function restoreTopLegend(productGrouping) {
      const { labelSpan, valueSpan } = getTopLegendSpans(productGrouping);
      if (labelSpan) labelSpan.textContent = labelSpan.dataset.defaultLabel ?? labelSpan.textContent;
      if (valueSpan) valueSpan.textContent = valueSpan.dataset.defaultValue ?? valueSpan.textContent;
    }

    function bindSwatchContainer(productGrouping, swatchContainer) {
      if (boundContainers.has(swatchContainer)) return;
      boundContainers.add(swatchContainer);

      const isExtensionSwatches = swatchContainer.classList.contains(
        'product-grouping__swatches--extended',
      );
      const valueDatasetKey = isExtensionSwatches ? 'defaultExtension' : 'defaultColor';
      const labelSelector = isExtensionSwatches
        ? 'label[data-extension-name]'
        : 'label[data-color-name]';

      const getLegendValueSpan = () =>
        swatchContainer.previousElementSibling?.querySelector('.product-grouping__color') ?? null;

      const getValueName = (label) =>
        isExtensionSwatches ? label.dataset.extensionName : label.dataset.colorName;

      const getCategoryLabelText = () => {
        const categoryLabel = getCategoryLabel(swatchContainer.previousElementSibling);
        return categoryLabel ? `${categoryLabel}:  ` : '';
      };

      const initialValueSpan = getLegendValueSpan();
      if (initialValueSpan?.dataset[valueDatasetKey]) {
        initialValueSpan.textContent = initialValueSpan.dataset[valueDatasetKey];
      }

      swatchContainer.addEventListener('mouseover', (event) => {
        const label = event.target.closest(labelSelector);
        if (!label || !swatchContainer.contains(label)) return;
        const valueName = getValueName(label);
        if (!valueName) return;
        const valueSpan = getLegendValueSpan();
        if (valueSpan) valueSpan.textContent = valueName;
        setTopLegend(productGrouping, getCategoryLabelText() || null, valueName);
      });

      swatchContainer.addEventListener('mouseout', (event) => {
        const label = event.target.closest(labelSelector);
        if (!label) return;
        if (event.relatedTarget && label.contains(event.relatedTarget)) return;
        const valueSpan = getLegendValueSpan();
        const defaultValue = valueSpan?.dataset[valueDatasetKey];
        if (valueSpan && defaultValue) valueSpan.textContent = defaultValue;
        restoreTopLegend(productGrouping);
      });

      swatchContainer.addEventListener('change', (event) => {
        const input = event.target.closest('input[type="radio"]');
        if (!input) return;
        const label = input.closest(labelSelector);
        if (!label) return;
        const valueName = getValueName(label);
        if (!valueName) return;

        const valueSpan = getLegendValueSpan();
        if (valueSpan) {
          valueSpan.dataset[valueDatasetKey] = valueName;
          valueSpan.textContent = valueName;
        }

        const categoryLabelText = getCategoryLabelText();
        const { labelSpan: topLabelSpan, valueSpan: topValueSpan } =
          getTopLegendSpans(productGrouping);
        if (topLabelSpan && categoryLabelText) topLabelSpan.dataset.defaultLabel = categoryLabelText;
        if (topValueSpan) topValueSpan.dataset.defaultValue = valueName;
        setTopLegend(productGrouping, categoryLabelText || null, valueName);
      });
    }

    function initializeProductGroupingHover() {
      const productGroupings = document.querySelectorAll('.product-grouping');
      if (!productGroupings.length) return;

      productGroupings.forEach((productGrouping) => {
        // Ensure the top legend starts from its server-rendered defaults.
        restoreTopLegend(productGrouping);

        const swatchContainers = productGrouping.querySelectorAll('.product-grouping__swatches');
        swatchContainers.forEach((swatchContainer) => {
          bindSwatchContainer(productGrouping, swatchContainer);
        });
      });
    }

    initializeProductGroupingHover();

    let reinitScheduled = false;
    const observer = new MutationObserver((mutations) => {
      if (reinitScheduled) return;
      let shouldReinit = false;
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (
            node.nodeType === 1 &&
            (node.classList?.contains('product-grouping') ||
              node.querySelector?.('.product-grouping'))
          ) {
            shouldReinit = true;
            break;
          }
        }
        if (shouldReinit) break;
        if (
          mutation.type === 'attributes' &&
          mutation.target.classList?.contains('product-grouping')
        ) {
          shouldReinit = true;
          break;
        }
      }
      if (shouldReinit) {
        reinitScheduled = true;
        requestAnimationFrame(() => {
          reinitScheduled = false;
          initializeProductGroupingHover();
        });
      }
    });

    const main = document.querySelector('main');
    if (main) {
      observer.observe(main, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-product-id', 'data-product-url'],
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
